module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BusinessUnitView.jsx"));
	}, "BusinessUnit");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BusinessUnit!./src/pages/bundle-org-mgmt/BusinessCellUnit/BusinessUnitView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=BusinessUnit!./src/pages/bundle-org-mgmt/BusinessCellUnit/BusinessUnitView.jsx
// module chunks = 43